import React from 'react';
import Button from '@mui/material/Button';
import { toast } from "react-toastify";

const ToastMessage = {
    Success: (text?: string) => toast.success(text || 'Operation was completed successfully!'),
    Failed: (text?: string) => toast.error(text || 'Operation failed!'),
    Warn: (text?: string) => toast.warn(text || 'Warn!'),
    Confirm: (text?: string): Promise<boolean> => {
        document.body.classList.add('unclickable');
        return new Promise((resolve) => {
            toast(
                <ConfirmDialog
                    text={text || 'Are you sure you want to delete this item?'}
                    resolve={result => {
                        document.body.classList.remove('unclickable');
                        resolve(result);
                    }}
                />,
                {
                    autoClose: false,
                    position: 'top-center',
                    className: 'clickable',
                    onClose: () => document.body.classList.remove('unclickable')
                }
            );
        });
    },
    Info: (text?: string) => toast.info(text || 'Operation was completed successfully!'),
};

const ConfirmDialog = ({ text, resolve }: { text: string; resolve: (result: boolean) => void }) => {
    return (
        <div>
            <p>{text || 'Are you sure you want to delete this item?'}</p>
            <Button
                onClick={() => {
                    resolve(true);
                    toast.dismiss();
                    document.body.classList.remove('unclickable');
                }}
            >
                Yes
            </Button>
            <Button
                color='error'
                onClick={() => {
                    resolve(false);
                    toast.dismiss();
                    document.body.classList.remove('unclickable');
                }}>
                No
            </Button>
        </div>
    );
};

export default ToastMessage;